import { WhiteLabelStyles, themes } from 'signer-app';

export const whiteLabelingNew: WhiteLabelStyles = themes.vis2023;

export type WhiteLabelingPropertyIdNew = keyof typeof whiteLabelingNew;
